import { Dispatch, SetStateAction, useCallback } from "react";

import type { Draft } from "./inboxDraft.types";

/**
 * The setters for the active draft's own fields (CC, BCC, the CC/BCC toggle, the subject).
 * Extracted from `useAddInboxChat`, which may not grow.
 */
export const useActiveDraftFields = (
	setDrafts: Dispatch<SetStateAction<Draft[]>>,
	activeDraftIndex: number
) => {
	const updateActive = useCallback(
		(change: (draft: Draft) => Partial<Draft>) =>
			setDrafts((prev) =>
				prev.map((d, i) => (i === activeDraftIndex ? { ...d, ...change(d) } : d))
			),
		[setDrafts, activeDraftIndex]
	);

	return {
		handleUpdateDraftCc: useCallback(
			(cc: string[]) => updateActive(() => ({ cc })),
			[updateActive]
		),
		handleUpdateDraftBcc: useCallback(
			(bcc: string[]) => updateActive(() => ({ bcc })),
			[updateActive]
		),
		handleToggleCcBcc: useCallback(
			() => updateActive((d) => ({ showCcBcc: !d.showCcBcc })),
			[updateActive]
		),
		handleUpdateDraftSubject: useCallback(
			(subject: string) => updateActive(() => ({ subject })),
			[updateActive]
		),
	};
};
